import React, { useState, useEffect, useContext } from 'react';

import { Card, InfoTray } from 'src/components';
import { SelectedTransactionContext } from 'src/context/selected-transaction-context';
import { ComingSoonLabel } from 'src/assets/images';

import './transaction-view.scss';

/*
  props:

  cards: optional
    Array of cards (2d array) that will be displayed.
    Each card contains an array of objects with name-value pairs to display:
      e.g. [[{name: 'card0row0', value: '...'}, {name: 'card0row1', value: '...'}], [{name: 'card1row0', value: '...'}]]
    If left out, nothing will be displayed

  sendReceiptOnClick: optional
    The function that will be called when the send receipt button is clicked
    Defaults to () => {}

  title: optional
    Defaults to "Transaction details"

  isFullscreen
    Defaults to false

  mobileTitle
    Defaults to "Transactions"
*/
export default function TransactionView(props) {
  const [selectedTransaction, setSelectedTransaction] = useContext(SelectedTransactionContext);
  const [displayClass, setDisplayClass] = useState('');
  const [isFirstTransaction, setIsFirstTransaction] = useState(true);

  useEffect(() => {
    if(!!selectedTransaction) {
      setDisplayClass('show');
    }
    else if (!isFirstTransaction) {
      setDisplayClass('hide')
    }

    if (!!selectedTransaction && isFirstTransaction) {
      setIsFirstTransaction(false);
    }
  }, [selectedTransaction, isFirstTransaction]);

  return (
    <div className={`TransactionView ${displayClass} ${props.className || ''}`} data-testid="transaction-view">
      <InfoTray
        selected={!!selectedTransaction}
        setSelected={(res) => setSelectedTransaction(res)}
        title={props.title || "Transaction details"}
        isFullscreen={props.isFullscreen || ''}
      >
        {selectedTransaction && (
          <>
            <p className="top-mobile-page-title navbar-title-mobile is-hidden-tablet">
              { props.mobileTitle || "Transactions" }
            </p>
            <div className="transaction-cards-container">
              { props.cards.map((card, cIndex) => (
                card.length > 0 ?
                  <Card key={cIndex}>
                    <table className="table is-fullwidth">
                      <tbody>
                        { card.map((row, rIndex) => (
                          row.value ?
                          <tr key={rIndex}>
                            <td>
                              <p className="has-text-weight-light is-size-7 subtext">
                                {row.name}
                              </p>
                              <p className="table-data-value">
                                {row.value}
                              </p>
                            </td>
                          </tr>
                          : <></>
                        ))}
                      </tbody>
                    </table>
                  </Card>
                : <></>
              )) }
              <button className="send-receipt-button button is-hidden-mobile">
                <span>Send receipt</span>
                <img className="coming-soon-label" src={ComingSoonLabel} alt="coming soon label"></img>
              </button>
            </div>
          </>
        )}
      </InfoTray>
      {selectedTransaction && (
        <button className="send-receipt-button button is-hidden-tablet">
          <span>Send receipt</span>
          <img className="coming-soon-label" src={ComingSoonLabel} alt="coming soon label"></img>
        </button>
      )}
    </div>
  );
}
